import { EndPoint } from "../../components/common/config";
import { handleNotify, TOASTER_POSITION, TOASTER_TYPE } from "../../components/common/notification/toaster_notify.component";

let DEFAULT_LOCALE = "en-IN";

export function getDateFormat() {
    const localeDateFormats = {
        "en-IN": "dd-MM-yyyy",
        "en-US": "MM/dd/yyyy",
        "fr-FR": "dd/MM/yyyy",
    };
    return localeDateFormats[DEFAULT_LOCALE] || "dd-MM-yyyy";
}

export function getCurrentLocale() {
    return DEFAULT_LOCALE;
}

//backend locale fetch
export async function fetchDefaultLocale() {
  try {
    const res = await fetch(EndPoint.LOCALE);
    const data = await res.json();

    if (data && data.locale) {
      DEFAULT_LOCALE = data.locale;
    }
  } catch (err) {
    handleNotify(
      "Failed to fetch locale, using default",
      err.message || "Unknown error",
      TOASTER_TYPE.ERROR,
      TOASTER_POSITION.TOP_RIGHT
    );
  }
}
